<div class="chart-container">
  <div [id]="chartId" class="chartdiv"></div>
  <div *ngIf="dataIsLoading" class="loading-overlay" data-testid="loading-overlay">Loading...</div>
</div>
